import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService, RechargeService } from '@app/core/services';
import { User } from '@app/models/backend';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-deduction-modal',
  templateUrl: './deduction-modal.component.html',
  styleUrls: ['./deduction-modal.component.scss']
})
export class DeductionModalComponent implements OnInit {

  user!: User
  form!: FormGroup;
  adjustmentTypes!: any;

  submitted: boolean = false;
  success: boolean = false;

  constructor(private fb: FormBuilder,
              private rechargeService: RechargeService,
              private notification: NotificationService,
              private modalRef: BsModalRef) { }

  ngOnInit(): void {
    this.initForm();
  }

  // -- Submit -- //
  submit() {
    const data =
      {
        amount: this.form.value.amount,
        businessId: this.user.businessId,
        gst: this.form.value.gst === null ? 0 : this.form.value.gst,
        wht: this.form.value.wht === null ? 0 : this.form.value.wht,
        adjustmentTypeId: this.form.value.adjustmentTypeId,
      };
    let amount = this.form.value.amount;
    this.rechargeService.deductBalance(data).subscribe((res: any) => {
      this.submitted = true;
      this.success = true;
      this.notification.success(res['message']);
    }, error => {
      this.notification.error(error['message']);
    });
  }

  // -- Close Modal -- //
  close(): void {
    this.modalRef.hide();
  }

  // -- Init Form -- //
  initForm(): void {
    this.form = this.fb.group({
      amount: [0, Validators.required],
      gst: [0, null],
      wht: [0, null],
      adjustmentTypeId: ['', Validators.required]
    });
  }

}
